import { ENABLE_EGG } from '../../mutation-types';


export function enable({ commit }, { name }) {
    commit(ENABLE_EGG, { name });
}
